/**
 * Animated three-dot loading indicator.
 * Dots bounce and shift opacity in sequence to create a wave effect.
 * Keyframes defined in index.css as `loading-dot`.
 */
const LoadingDots = () => (
    <div className="flex gap-1">
        {[0, 1, 2].map(i => (
            <span
                key={i}
                className="size-2 rounded-full bg-teal-600"
                style={{ animation: 'loading-dot 1.2s ease-in-out infinite', animationDelay: `${i * 0.2}s` }}
            />
        ))}
    </div>
);

export default LoadingDots;
